import { useContext } from "react";
import { ConfirmContext, type ConfirmContextValue } from "./confirm-context";

export function useConfirm(): ConfirmContextValue {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error("useConfirm must be used within a ConfirmDialogProvider");
  return ctx;
}
